export default "__VITE_ASSET__a56fd076__"